import {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import {useHistory, useLocation, withRouter} from 'react-router-dom';
import {PinataState} from "../../store/types";
import {loadUserInfo} from "../../store/user/user.actions";
import {Box, CircularProgress, Container, Link, Typography} from "@mui/material";
import {usePostUsersAccountConnect} from "../../hooks/queries/useUsers";

const DiscordAuth = (props: {loadUserInfo: any}) => {
  const history = useHistory();
  const {search} = useLocation();
  const {isLoading, error, isSuccess, mutate} = usePostUsersAccountConnect();
  console.log(search)

  const handleDiscordAuth = async () => {
    const hashParams = window.location.href.match(/#(.+)/);
    const discordAccessToken = new URLSearchParams(hashParams![1]).get('access_token');
    fetch('https://discord.com/api/v9/users/@me', {
      headers: {
        Authorization: `Bearer ${discordAccessToken}`
      }
    })
      .then(res => res.json())
      .then(data => {
        mutate(data.id)
      });
  }

  useEffect(() => {
    handleDiscordAuth();
  }, [])

  useEffect(() => {
    isSuccess && history.push('/integrations');
  }, [isSuccess]);

  return <Container>
    <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column"}}>
      {
        isSuccess ? <Typography>Discord set up. <Link href={'/integrations'}>Go Back</Link></Typography>
          : <> <CircularProgress /> <Typography variant={"h5"}>Setting up discord...</Typography> </>
      }
    </Box>
  </Container>;
};

const mapStateToProps = (state: PinataState) => {
  return {
    user: state.user.user
  }
};

export default withRouter(connect(mapStateToProps, {loadUserInfo})(DiscordAuth));